import { Analytics } from "@shared"

import CircleButtonComponent from "./CircleButton"

const CircleButton = Analytics(CircleButtonComponent, true)

export { CircleButton }
export default CircleButton
